const handleError = (reason: unknown) => {
  console.error(reason);

  return null;
};
/* jscpd:ignore-start */
export const handleJSONResponse = async (response: Response) => {
  if (response.status === 401) {
    // ? No clue if this is alright.
    window.location.href = "/login";
  }

  const data = await response.json().catch(handleError);

  if (!response.ok || data == null) {
    if (data) {
      return new Error(data.message);
    }

    return new Error(
      "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
    );
  }

  return data;
};

export const handleTextResponse = async (
  response: Response,
): Promise<string | Error> => {
  if (response.status === 401) {
    // ? No clue if this is alright.
    window.location.href = "/login";
  }

  const data = await response.text().catch(handleError);

  if (!response.ok || data == null) {
    if (data) {
      return new Error(data);
    }

    return new Error(
      "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
    );
  }

  return data;
};
/* jscpd:ignore-end */
